(function() {
    $(document).on('click', '.js-change-bg-color', function(e) {
        e.preventDefault();
        var color = $(this).data('change-bg-color-to');
        $(this).attr('style', 'background-color: ' + color + ' !important');
    });
})();
